import React, { useRef, useState } from "react";
import { Alert, Button, Label } from 'reactstrap';
import { AvForm, AvGroup, AvInput, AvFeedback } from 'availity-reactstrap-validation';
import Typography from "@material-ui/core/Typography";
import CheckCircleRoundedIcon from "@material-ui/icons/CheckCircleRounded";
import LockRoundedIcon from "@material-ui/icons/LockRounded";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import "../HomeSections.css";

const FREE_FEATURES = [
  { item: "AI vehicle insights", available: true },
  { item: "Instant MOT history summary", available: true },
  { item: "Tax and SORN status", available: true },
  { item: "Outstanding finance", available: false },
  { item: "Stolen check", available: false },
  { item: "Mileage discrepancies", available: false },
  { item: "Insurance write-off", available: false },
  { item: "Full plate-change history", available: false }
];

const PREMIUM_FEATURES = [
  { item: "Everything in the free report", available: true },
  { item: "Outstanding finance", available: true },
  { item: "Stolen check", available: true },
  { item: "Mileage discrepancies", available: true },
  { item: "Insurance write-off", available: true },
  { item: "Scrapped and imported records", available: true },
  { item: "Full plate-change history", available: true },
  { item: "Comprehensive vehicle history", available: true }
];

const FeatureList = ({ features }) => (
  <ul className="rc-plan-list">
    {features.map((feature, i) => (
      <li key={i} className={feature.available ? "" : "is-locked"}>
        {feature.available
          ? <CheckCircleRoundedIcon className="rc-icon-yes" fontSize="small" />
          : <LockRoundedIcon className="rc-icon-locked" fontSize="small" />}
        <span>{feature.item}</span>
      </li>
    ))}
  </ul>
);

const ReportStepOneComponent = ({
                                  reg,
                                  onChange,
                                  prodOptSelect,
                                  onBuy,
                                  error,
                                  notification,
                                  hpiCost,
                                  userNavigatesFrom
}) => {

  const [selectedCard, setSelectedCard] = useState(null);
  const avFormRef = useRef(null);
  const [nextStageText, setNextStageText] = useState("");

  const handleCardSelect = (card) => {
    setSelectedCard(card);
    if (card === "free") {
      setNextStageText("Where should we send your free MOT report? It arrives instantly.");
      prodOptSelect(reg, "free")
    } else {
      setNextStageText("Where should we send your full report? You will also see it on screen straight after payment.");
      prodOptSelect(reg, "premium")
    }
    avFormRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const hideFreeOption = userNavigatesFrom === "ai";

  return (
    <section className="gen-section filter_space">
      <div className="container mobile_padding" style={{ paddingBottom: '72px' }}>

        {notification &&
          <div style={{ padding: "16px 0px 8px 0px" }}>
            <Alert color={error ? "danger" : "success"}>{notification}</Alert>
          </div>
        }

        <div className="rc-section-head" style={{ marginBottom: 24 }}>
          <h2>Choose your report</h2>
          <p>
            <span className="report-plate">{reg}</span>
          </p>
        </div>

        <div className="row justify-content-center align-items-stretch">
          {!hideFreeOption && (
            <div className="col-lg-5 col-md-6 col-12 mt-4">
              <div
                className={selectedCard === "free" ? "rc-plan is-selected" : "rc-plan"}
              >
                <div className="rc-plan-name">MOT Analysis</div>
                <div className="rc-plan-price">Free</div>
                <p className="rc-plan-strap">A useful start, but not the full picture.</p>

                <FeatureList features={FREE_FEATURES} />

                <button
                  type="button"
                  className="rc-cta rc-cta--ghost"
                  onClick={() => handleCardSelect("free")}
                >
                  {selectedCard === "free" ? "Selected" : "Continue with free"}
                </button>
              </div>
            </div>
          )}

          <div className={hideFreeOption ? "col-lg-6 col-md-8 col-12 mt-4" : "col-lg-5 col-md-6 col-12 mt-4"}>
            <div
              className={
                selectedCard === "premium"
                  ? "rc-plan rc-plan--featured is-selected"
                  : "rc-plan rc-plan--featured"
              }
            >
              <div className="rc-plan-badge">RECOMMENDED</div>
              <div className="rc-plan-name">Full Report</div>
              <div className="rc-plan-price">£{hpiCost}</div>
              <p className="rc-plan-strap">
                Everything a seller might not tell you. One payment, no subscription.
              </p>

              <FeatureList features={PREMIUM_FEATURES} />

              <button
                type="button"
                className="rc-cta"
                onClick={() => handleCardSelect("premium")}
              >
                {selectedCard === "premium" ? "Selected" : `Get full report £${hpiCost}`}
              </button>
            </div>
          </div>
        </div>

        {/* Email capture: only meaningful once a report has been picked */}
        <div ref={avFormRef} className="rc-next-step">
          {selectedCard ? (
            <div className="rc-email-card">
              <Typography variant="body1" style={{ marginBottom: 16 }}>
                {nextStageText}
              </Typography>
              <AvForm onValidSubmit={onBuy.bind(this, 3, selectedCard)}>
                <AvGroup>
                  <Label for="userEmail" className="form-input">Email</Label>
                  <AvInput
                    name="userEmail"
                    type="email"
                    onChange={onChange}
                    required
                    placeholder="you@example.com"
                    maxLength={255}
                  />
                  <AvFeedback>A valid email is required.</AvFeedback>
                </AvGroup>
                <Button type="submit" className="rc-cta" style={{ marginTop: 12 }}>
                  {selectedCard === "premium" ? "Continue to payment" : "Send my free report"}
                </Button>
                <p className="rc-reassure">
                  <LockOutlinedIcon style={{ fontSize: 15 }} />{' '}
                  {selectedCard === "premium"
                    ? "Secure payment. We only use your email to send the report."
                    : "We only use your email to send the report."}
                </p>
              </AvForm>
            </div>
          ) : (
            <p className="rc-choose-prompt">Pick a report above to continue</p>
          )}
        </div>
      </div>
    </section>
  )
}

export default ReportStepOneComponent;
